import Vue from 'vue';
import store from '../../store';
import recipeTransformer from '../../transformers/recipe';

const success = ({ data }, resolve) => {
  const recipes = recipeTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllRecipes', recipes);
  resolve(recipes);
};

const failed = () => {};


export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('/production/recipe')
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/recipe/all.js